import {
  getGlobalPayments,
  downloadGlobalPaymentsList
} from 'src/services/transactionsService';
import { asyncActionCreator } from 'src/utils/loadingUtils';
import { SnackBarVariants } from 'src/utils/constants/common';
import { toMexicoCityInstant } from 'src/utils/momentLocalTimezone';
import { selectGlobalPaymentsQueryOptions } from '../selectors/globalPaymentSelectors';
import { showMessage } from './snackBarActions';

export const LOAD_GLOBAL_PAYMENTS = asyncActionCreator('LOAD_GLOBAL_PAYMENTS');
export const DOWNLOAD_GLOBAL_PAYMENTS_LIST = asyncActionCreator(
  'DOWNLOAD_GLOBAL_PAYMENTS_LIST'
);
export const SAVE_GLOBAL_PAYMENTS_OPTIONS = 'SAVE_GLOBAL_PAYMENTS_OPTIONS';
export const CLEAR_GLOBAL_PAYMENTS = 'CLEAR_GLOBAL_PAYMENTS';

function getRequestOptions(getState) {
  const queryOpts = selectGlobalPaymentsQueryOptions(getState());
  const reqOptions = {};

  if (queryOpts.page > 0) {
    reqOptions.offset =
      queryOpts.page * Number(process.env.REACT_APP_TABLE_SIZE);
  }
  if (queryOpts.search) {
    reqOptions.search = queryOpts.search;
  }
  if (queryOpts.originChannel) {
    reqOptions.originChannel = queryOpts.originChannel;
  }
  if (queryOpts.afterDate) {
    reqOptions.afterDate = toMexicoCityInstant(queryOpts.afterDate)
      .startOf('day')
      .toISOString();
  }
  if (queryOpts.beforeDate) {
    reqOptions.beforeDate = toMexicoCityInstant(queryOpts.beforeDate)
      .endOf('day')
      .toISOString();
  }

  return reqOptions;
}

export const loadGlobalPayments = options => async (dispatch, getState) => {
  try {
    dispatch({ type: LOAD_GLOBAL_PAYMENTS.start });
    dispatch({ type: SAVE_GLOBAL_PAYMENTS_OPTIONS, options });

    const reqOptions = getRequestOptions(getState);
    reqOptions.limit = selectGlobalPaymentsQueryOptions(getState()).limit;

    const response = await getGlobalPayments(reqOptions);

    return dispatch({
      type: LOAD_GLOBAL_PAYMENTS.success,
      ...response
    });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: LOAD_GLOBAL_PAYMENTS.failure });
  }
};

export const downloadGlobalPaymentsListAction = () => async (
  dispatch,
  getState
) => {
  try {
    dispatch({ type: DOWNLOAD_GLOBAL_PAYMENTS_LIST.start });

    const reqOptions = getRequestOptions(getState);
    await downloadGlobalPaymentsList(reqOptions);

    return dispatch({ type: DOWNLOAD_GLOBAL_PAYMENTS_LIST.success });
  } catch (error) {
    dispatch(
      showMessage({ message: error.message, variant: SnackBarVariants.ERROR })
    );
    return dispatch({ type: DOWNLOAD_GLOBAL_PAYMENTS_LIST.failure });
  }
};

export const clearGlobalPayments = () => dispatch => {
  dispatch({ type: CLEAR_GLOBAL_PAYMENTS });
};
